import React, { FC } from 'react';
import { ui } from 'util/ui';

/**
 * The "drop files here" area behind a bucket's file list (UI refresh, 5 Nov 2026): a rounded dashed box
 * with an upload mark, which turns the accent colour while files are dragged over it. Purely visual;
 * the dropzone around it does the work.
 */
const DropHint: FC<{ text: string; active?: boolean; inset?: number }> = ({ text, active = false, inset = 10 }) => (
  <div
    aria-hidden="true"
    style={{
      position: 'absolute',
      top: inset,
      left: inset,
      right: inset,
      bottom: inset,
      border: `1.5px dashed ${active ? ui.accent : '#D5D9DF'}`,
      borderRadius: 12,
      background: active ? 'rgba(229,5,106,0.05)' : 'transparent',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      color: active ? ui.accent : '#8A909B',
      fontFamily: ui.font,
      fontSize: 13,
      fontWeight: 500,
      textAlign: 'center',
      padding: 12,
      pointerEvents: 'none',
      transition: 'border-color 0.15s ease, background 0.15s ease',
    }}
  >
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 16V4M7 8.5l5-5 5 5M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" />
    </svg>
    {active ? 'Drop to upload' : text}
  </div>
);

export default DropHint;
